import { Directive } from '@angular/core';

@Directive({
  selector: '[app-card-content]',
  host: { class: 'block px-5 first:pt-5 last:pb-5' },
})
export class CardContentDirective {}
